export default __webpack_public_path__ + "static/media/sponsor7.1ee34d75.jpg";